(function () {
  if (window.__m3d) return;
  window.__m3d = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;
  function show(el) { el.classList.add('is-in'); }
  function scan() {
    var els = document.querySelectorAll('.m3d-reveal:not(.is-in), .m3d-lines:not(.is-in)');
    var design = document.documentElement.classList.contains('shopify-design-mode');
    if (reduce || design || !('IntersectionObserver' in window)) {
      els.forEach(show);
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* Product gallery: every photo sits in the same 4:5 frame and fills it. A photo whose real shape is far from
     that (very tall or landscape) is shown whole instead, so nothing important is ever cropped off. */
  function fit(img) {
    if (!img.naturalWidth || !img.naturalHeight) return;
    var r = img.naturalWidth / img.naturalHeight;
    var box = img.closest('.product-media-container');
    if (box) box.classList.toggle('m3d-fit-contain', r < 0.65 || r > 1.3);
  }
  function scanMedia() {
    document.querySelectorAll('.product-media-container img').forEach(function (img) {
      if (img.complete) fit(img);
      else img.addEventListener('load', function () { fit(img); }, { once: true });
    });
  }

  function init() { scan(); scanMedia(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', scanMedia);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('variant:update', function () { setTimeout(scanMedia, 150); });
})();